import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function PrintOrder() {
  return <div className="min-h-screen bg-white p-8 max-w-4xl mx-auto" data-id="element-1412" data-mp="ifiz1ef9bea3">
      <div className="mb-8 print:hidden" data-id="element-1413" data-mp="3rpgbkuvjvna">
        <Button onClick={() => window.print()} className="gap-2" data-id="element-1414" data-mp="3qw9kjvx1655">
          <Printer className="h-4 w-4" data-id="element-1415" data-mp="8p7imsedzcmb" />
          Print Order
        </Button>
      </div>

      <div className="border border-slate-200 p-8 space-y-8" data-id="element-1416" data-mp="3qvm6pk6dd2yf">
        {/* Header */}
        <div className="flex justify-between items-start" data-id="element-1417" data-mp="3vuoyw4193eoz">
          <div data-id="element-1418" data-mp="3vsvt0qygoyi1">
            <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1419" data-mp="3vsm4l7t2ezeg">
              Desert Sage Seminars
            </h1>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1420" data-mp="3lwj4e7hrxau5">
              <p data-id="element-1421" data-mp="3lyvho7cl6x0v">123 Education Lane</p>
              <p data-id="element-1422" data-mp="1f5tdezwrdzwk">Phoenix, AZ 85001</p>
              <p data-id="element-1423" data-mp="1f6uov5hosoet">CALL US: (555) 123-4567</p>
              <p data-id="element-1424" data-mp="1k5fs7ds8jo7h">Fax: (555) 987-6543</p>
              <p data-id="element-1425" data-mp="1k4cvuqc58tk6">E-Mail: info@desertsageseminars.com</p>
            </div>
          </div>
          <div className="text-right text-sm space-y-1" data-id="element-1426" data-mp="1qa8805gkipkk">
            <p data-id="element-1427" data-mp="1q8nb496s6ujj">
              <span className="font-semibold" data-id="element-1428" data-mp="1lc6kn8c4043a">Date:</span> 2023-10-15
            </p>
            <p data-id="element-1429" data-mp="200tcuamu4qbx">
              <span className="font-semibold" data-id="element-1430" data-mp="200ji69quhuzw">Order id:</span> ORD-2023-001
            </p>
            <p data-id="element-1431" data-mp="1v1q9qvqf0u6l">
              <span className="font-semibold" data-id="element-1432" data-mp="1v16pv9h7fvpx">Order status:</span> Processed
            </p>
          </div>
        </div>

        <hr className="border-slate-200" data-id="element-1433" data-mp="17d712f3gefdz" />

        {/* Customer Info */}
        <div className="grid grid-cols-2 gap-8" data-id="element-1434" data-mp="12dkkbvof2h0f">
          <div data-id="element-1435" data-mp="12evmjr27rgpf">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-1436" data-mp="12fdsjfeoh9aj">Customer Info</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1437" data-mp="1gedegfat3a30">
              <p data-id="element-1438" data-mp="1cayzlrylszr5">
                <span className="font-semibold" data-id="element-1439" data-mp="1cafjmgsiklfr">Company:</span> Acme Landscaping
              </p>
              <p data-id="element-1440" data-mp="2rqo103yyi9z0">
                <span className="font-semibold" data-id="element-1441" data-mp="2rq5xcm9ysth2">First Name:</span> John
              </p>
              <p data-id="element-1442" data-mp="2npue9dx9317p">
                <span className="font-semibold" data-id="element-1443" data-mp="2nsgl1bcbhcov">Last Name:</span> Doe
              </p>
              <p data-id="element-1444" data-mp="1keyifh3u0d9m">
                <span className="font-semibold" data-id="element-1445" data-mp="1khkp7eiweoqs">Phone:</span> 555-0123
              </p>
              <p data-id="element-1446" data-mp="1pcq8e5kx1pb6">
                <span className="font-semibold" data-id="element-1447" data-mp="1pge1x4qd2bpw">Fax:</span> -
              </p>
              <p data-id="element-1448" data-mp="1uefhhfokvswm">
                <span className="font-semibold" data-id="element-1449" data-mp="1ubtdtr4t5xjo">E-Mail:</span> john@example.com
              </p>
              <p data-id="element-1450" data-mp="1ycwswbf17pju">
                <span className="font-semibold" data-id="element-1451" data-mp="11p8lancljfej">URL:</span> -
              </p>
            </div>
          </div>
          <div data-id="element-1452" data-mp="16njuqwyzbnw8">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-1453" data-mp="16p4qgpx15cvo">Billing Address</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1454" data-mp="1ap5448cb1k1o">
              <p data-id="element-1455" data-mp="1ankb4n5n295x">
                <span className="font-semibold" data-id="element-1456" data-mp="1fgdf38ta9dgy">Address:</span> 123 Desert Way
              </p>
              <p data-id="element-1457" data-mp="iyh4x1u6yoqn">
                <span className="font-semibold" data-id="element-1458" data-mp="iz0o0lvkvj69">City:</span> Phoenix
              </p>
              <p data-id="element-1459" data-mp="n02o14xbjz9a">
                <span className="font-semibold" data-id="element-1460" data-mp="mzkh9ed162n4">State:</span> AZ
              </p>
              <p data-id="element-1461" data-mp="fgl4hrk2r9cq">
                <span className="font-semibold" data-id="element-1462" data-mp="fh33gvy4g1oc">Zip:</span> 85001
              </p>
            </div>
          </div>
        </div>

        {/* Products Table */}
        <table className="w-full text-sm text-left border-collapse" data-id="element-1463" data-mp="afdx3tlugc6l">
          <thead data-id="element-1464" data-mp="6ebs0w58x5wp">
            <tr className="bg-slate-50 border-y border-slate-200" data-id="element-1465" data-mp="6hzn3zqca0dj">
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-1466" data-mp="1fqu53dguybf">SKU</th>
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-1467" data-mp="3snmuf2fqk66y">
                Product
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-1468" data-mp="3nvbtbw99eect">
                Item price
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-center" data-id="element-1469" data-mp="3ixtk04rbxx4a">
                Quantity
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-1470" data-mp="3etvi5mame87j">
                Total
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200" data-id="element-1471" data-mp="34ytterk9b85h">
            <tr data-id="element-1472" data-mp="18umcn8fh2xhn">
              <td className="py-3 px-4" data-id="element-1473" data-mp="18tuje49clbuj">C-101</td>
              <td className="py-3 px-4" data-id="element-1474" data-mp="18wgz4r6e6xnu">Desert Ecology Basics</td>
              <td className="py-3 px-4 text-right" data-id="element-1475" data-mp="1dsfhny51hlgc">$49.00</td>
              <td className="py-3 px-4 text-center" data-id="element-1476" data-mp="z4ufc6fznq9h">1</td>
              <td className="py-3 px-4 text-right" data-id="element-1477" data-mp="z41efm3pnuz9">$49.00</td>
            </tr>
          </tbody>
        </table>

        {/* Totals */}
        <div className="flex justify-end" data-id="element-1478" data-mp="q3wajlxq7epu">
          <div className="w-64 space-y-2 text-sm" data-id="element-1479" data-mp="q2tmrmvp9se5">
            <div className="flex justify-between" data-id="element-1480" data-mp="u5hsvmt14l7f">
              <span className="text-slate-600" data-id="element-1481" data-mp="u69cs0d9kuhv">Subtotal:</span>
              <span className="font-medium" data-id="element-1482" data-mp="g5yon53c9u0e">$49.00</span>
            </div>
            <div className="flex justify-between" data-id="element-1483" data-mp="g81nmemgyxh9">
              <span className="text-slate-600" data-id="element-1484" data-mp="l5upivgqp5bq">Coupon saving (SUMMER23):</span>
              <span className="font-medium text-green-600" data-id="element-1485" data-mp="2aj8217z09znx">-$10.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-200 pt-2" data-id="element-1486" data-mp="2fiko3qi1z2pg">
              <span className="text-slate-600" data-id="element-1487" data-mp="3vh34824bvuh">Discounted subtotal:</span>
              <span className="font-medium" data-id="element-1488" data-mp="3vqthwr2s50p">$39.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-900 pt-2 text-base font-bold" data-id="element-1489" data-mp="3v33buf3p2oi7">
              <span data-id="element-1490" data-mp="dm29iho1a4ny">Total:</span>
              <span data-id="element-1491" data-mp="dn3m4qkp6z7s">$39.00</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-slate-200 text-center" data-id="element-1492" data-mp="8spmud2x07xu">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-50 rounded border border-slate-200" data-id="element-1493" data-mp="mk45ujwto94w">
            <span className="font-bold text-slate-700" data-id="element-1494" data-mp="hoykpnb8uyhv">Authorize.Net</span>
            <span className="text-xs text-slate-500" data-id="element-1495" data-mp="wjmngtp9fits">
              Secure Payment Processing
            </span>
          </div>
        </div>
      </div>
    </div>;
}